<script setup lang="ts">
import {computed, ref} from 'vue';
import {Icon} from '@iconify/vue';
import Collapsible from '@/components/generic/Collapsible.vue';
import FileHistoryEntry from '@/components/file-history/FileHistoryEntry.vue';
import FilterHistoryButtons from '@/components/file-history/FilterHistoryButtons.vue';
import type {HistoryGroup} from '@/stores/useFileHistoryStore';
import {useFileHistoryActionButtons} from "@/composables/useFileHistoryActionButtons.ts";

const {group, defaultOpen = true} = defineProps<{
  group: HistoryGroup;
  defaultOpen?: boolean;
}>();
const isOpen = ref(defaultOpen);
const {isSelected} = useFileHistoryActionButtons(() => group.root)
const entryCount = computed(() => 1 + group.children.length);
</script>

<template>
  <div :class="isSelected? 'border-blue-400 ring-1 ring-blue-200':''">
    <Collapsible

        v-model:isOpen="isOpen" variant="default" :title="group.root.name || group.root.filename" icon="fa6-solid:folder"
    >

      <template #headerRight>

      <FilterHistoryButtons v-show="group.children.length" :entry="group.root"/>

        <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-500">
        {{ entryCount }}
      </span>
      </template>

      <div class="space-y-2">
        <FileHistoryEntry :entry="group.root"/>
        <div v-if="group.children.length" class="space-y-2 border-l-2 border-gray-100 pl-3">
          <FileHistoryEntry :showButtons="group.children?.length>1" v-for="child in group.children" :key="child.id" :entry="child" dense/>
        </div>
        <p v-else class="flex items-center gap-1.5 pl-1 text-xs text-gray-400">
          <Icon icon="fa6-solid:circle-info"/>
          Noch keine Transposition oder Konvertierung.
        </p>
      </div>
    </Collapsible>
  </div>
</template>
